module.exports = __webpack_public_path__ + "img/74ebae016998d5fae28c89076ff97744.4a8e11dd.png";